<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { allStatsItems } from "@/stats/statsItems";
import type { Stats } from "@/stats/types";
import { useGetStats } from "@/stats/useStats";
import StatsItem from "./StatsItem.vue";

const { stats, getStatsStatus } = useGetStats();

const statsKeys = Object.keys(allStatsItems) as Array<keyof Stats>;
</script>

<template>
  <ManagementLayout>
    <template #header>
      <h1>Statistiken</h1>
    </template>

    <HandleQueryStatus :query-status="getStatsStatus">
      <div class="grid box">
        <StatsItem v-for="key in statsKeys" :key="key">
          <template #header>
            <component :is="allStatsItems[key].icon" />
            {{ allStatsItems[key].text }}
          </template>
          {{ stats?.[key] }}
        </StatsItem>
      </div>
    </HandleQueryStatus>
  </ManagementLayout>
</template>
